/** TR3 element min/max lengths keyed by refDes (from ElementLengthCatalog.json). */
export const ELEMENT_LENGTH_BY_REF_DES = {
  "AAA01": { minLength: 1, maxLength: 1 },
  "AAA02": { minLength: 2, maxLength: 2 },
  "AAA03": { minLength: 2, maxLength: 2 },
  "AAA04": { minLength: 1, maxLength: 1 },
  "BHT01": { minLength: 4, maxLength: 4 },
  "BHT02": { minLength: 2, maxLength: 2 },
  "BHT03": { minLength: 1, maxLength: 50 },
  "BHT04": { minLength: 8, maxLength: 8 },
  "BHT05": { minLength: 4, maxLength: 8 },
  "BHT06": { minLength: 2, maxLength: 2 },
  "CL101": { minLength: 1, maxLength: 1 },
  "CL102": { minLength: 1, maxLength: 1 },
  "CL103": { minLength: 1, maxLength: 2 },
  "CL104": { minLength: 1, maxLength: 1 },
  "CR101": { minLength: 2, maxLength: 2 },
  "CR102": { minLength: 1, maxLength: 10 },
  "CR103": { minLength: 1, maxLength: 1 },
  "CR104": { minLength: 1, maxLength: 1 },
  "CR105": { minLength: 2, maxLength: 2 },
  "CR106": { minLength: 1, maxLength: 15 },
  "CR107": { minLength: 1, maxLength: 55 },
  "CR108": { minLength: 1, maxLength: 55 },
  "CR109": { minLength: 1, maxLength: 80 },
  "CR110": { minLength: 1, maxLength: 80 },
  "CR201": { minLength: 1, maxLength: 9 },
  "CR202": { minLength: 1, maxLength: 15 },
  "CR203": { minLength: 2, maxLength: 3 },
  "CR204": { minLength: 2, maxLength: 3 },
  "CR205": { minLength: 2, maxLength: 2 },
  "CR206": { minLength: 1, maxLength: 15 },
  "CR207": { minLength: 1, maxLength: 15 },
  "CR208": { minLength: 1, maxLength: 1 },
  "CR209": { minLength: 1, maxLength: 1 },
  "CR210": { minLength: 1, maxLength: 80 },
  "CR211": { minLength: 1, maxLength: 80 },
  "CR212": { minLength: 1, maxLength: 1 },
  "CR501": { minLength: 1, maxLength: 1 },
  "CR502": { minLength: 1, maxLength: 15 },
  "CR503": { minLength: 1, maxLength: 1 },
  "CR504": { minLength: 1, maxLength: 1 },
  "CR505": { minLength: 1, maxLength: 80 },
  "CR506": { minLength: 1, maxLength: 15 },
  "CR507": { minLength: 1, maxLength: 15 },
  "CR508": { minLength: 1, maxLength: 15 },
  "CR509": { minLength: 1, maxLength: 80 },
  "CR510": { minLength: 1, maxLength: 15 },
  "CR511": { minLength: 1, maxLength: 15 },
  "CR512": { minLength: 1, maxLength: 1 },
  "CR513": { minLength: 1, maxLength: 1 },
  "CR514": { minLength: 1, maxLength: 1 },
  "CR515": { minLength: 1, maxLength: 1 },
  "CR516": { minLength: 1, maxLength: 15 },
  "CR517": { minLength: 1, maxLength: 1 },
  "CR518": { minLength: 1, maxLength: 1 },
  "CR601": { minLength: 1, maxLength: 1 },
  "CR602": { minLength: 8, maxLength: 8 },
  "CR603": { minLength: 2, maxLength: 3 },
  "CR604": { minLength: 1, maxLength: 35 },
  "CR605": { minLength: 8, maxLength: 8 },
  "CR606": { minLength: 1, maxLength: 1 },
  "CR607": { minLength: 1, maxLength: 1 },
  "CR608": { minLength: 1, maxLength: 1 },
  "CR609": { minLength: 8, maxLength: 8 },
  "CR610": { minLength: 2, maxLength: 2 },
  "CR611": { minLength: 1, maxLength: 15 },
  "CR612": { minLength: 8, maxLength: 8 },
  "CR613": { minLength: 8, maxLength: 8 },
  "CR614": { minLength: 8, maxLength: 8 },
  "CR615": { minLength: 2, maxLength: 3 },
  "CR616": { minLength: 1, maxLength: 35 },
  "CR617": { minLength: 1, maxLength: 1 },
  "CR618": { minLength: 8, maxLength: 8 },
  "CR619": { minLength: 8, maxLength: 8 },
  "CR620": { minLength: 8, maxLength: 8 },
  "CR621": { minLength: 8, maxLength: 8 },
  "CRC01": { minLength: 2, maxLength: 2 },
  "CRC02": { minLength: 1, maxLength: 1 },
  "CRC03": { minLength: 2, maxLength: 3 },
  "CRC04": { minLength: 2, maxLength: 3 },
  "CRC05": { minLength: 2, maxLength: 3 },
  "CRC06": { minLength: 2, maxLength: 3 },
  "CRC07": { minLength: 2, maxLength: 3 },
  "DMG01": { minLength: 2, maxLength: 3 },
  "DMG02": { minLength: 1, maxLength: 35 },
  "DMG03": { minLength: 1, maxLength: 1 },
  "DMG04": { minLength: 1, maxLength: 1 },
  "DMG06": { minLength: 1, maxLength: 2 },
  "DMG07": { minLength: 2, maxLength: 3 },
  "DMG08": { minLength: 1, maxLength: 2 },
  "DMG09": { minLength: 1, maxLength: 15 },
  "DMG10": { minLength: 1, maxLength: 3 },
  "DMG11": { minLength: 1, maxLength: 30 },
  "DTP01": { minLength: 3, maxLength: 3 },
  "DTP02": { minLength: 2, maxLength: 3 },
  "DTP03": { minLength: 1, maxLength: 35 },
  "GE01": { minLength: 1, maxLength: 6 },
  "GE02": { minLength: 1, maxLength: 9 },
  "GS01": { minLength: 2, maxLength: 2 },
  "GS02": { minLength: 2, maxLength: 15 },
  "GS03": { minLength: 2, maxLength: 15 },
  "GS04": { minLength: 8, maxLength: 8 },
  "GS05": { minLength: 4, maxLength: 8 },
  "GS06": { minLength: 1, maxLength: 9 },
  "GS07": { minLength: 1, maxLength: 2 },
  "GS08": { minLength: 1, maxLength: 12 },
  "HCR01": { minLength: 1, maxLength: 2 },
  "HCR02": { minLength: 1, maxLength: 50 },
  "HCR03": { minLength: 1, maxLength: 30 },
  "HCR04": { minLength: 1, maxLength: 1 },
  "HI01-1": { minLength: 1, maxLength: 3 },
  "HI01-2": { minLength: 1, maxLength: 30 },
  "HI01-3": { minLength: 2, maxLength: 3 },
  "HI01-4": { minLength: 1, maxLength: 35 },
  "HI01-5": { minLength: 1, maxLength: 18 },
  "HI01-6": { minLength: 1, maxLength: 15 },
  "HI01-7": { minLength: 1, maxLength: 30 },
  "HI01-8": { minLength: 1, maxLength: 30 },
  "HI01-9": { minLength: 1, maxLength: 1 },
  "HI02-1": { minLength: 1, maxLength: 3 },
  "HI02-2": { minLength: 1, maxLength: 30 },
  "HI02-3": { minLength: 2, maxLength: 3 },
  "HI02-4": { minLength: 1, maxLength: 35 },
  "HI02-5": { minLength: 1, maxLength: 18 },
  "HI02-6": { minLength: 1, maxLength: 15 },
  "HI02-7": { minLength: 1, maxLength: 30 },
  "HI02-8": { minLength: 1, maxLength: 30 },
  "HI02-9": { minLength: 1, maxLength: 1 },
  "HI03-1": { minLength: 1, maxLength: 3 },
  "HI03-2": { minLength: 1, maxLength: 30 },
  "HI03-3": { minLength: 2, maxLength: 3 },
  "HI03-4": { minLength: 1, maxLength: 35 },
  "HI03-5": { minLength: 1, maxLength: 18 },
  "HI03-6": { minLength: 1, maxLength: 15 },
  "HI03-7": { minLength: 1, maxLength: 30 },
  "HI03-8": { minLength: 1, maxLength: 30 },
  "HI03-9": { minLength: 1, maxLength: 1 },
  "HI04-1": { minLength: 1, maxLength: 3 },
  "HI04-2": { minLength: 1, maxLength: 30 },
  "HI04-3": { minLength: 2, maxLength: 3 },
  "HI04-4": { minLength: 1, maxLength: 35 },
  "HI04-5": { minLength: 1, maxLength: 18 },
  "HI04-6": { minLength: 1, maxLength: 15 },
  "HI04-7": { minLength: 1, maxLength: 30 },
  "HI04-8": { minLength: 1, maxLength: 30 },
  "HI04-9": { minLength: 1, maxLength: 1 },
  "HI05-1": { minLength: 1, maxLength: 3 },
  "HI05-2": { minLength: 1, maxLength: 30 },
  "HI05-3": { minLength: 2, maxLength: 3 },
  "HI05-4": { minLength: 1, maxLength: 35 },
  "HI05-5": { minLength: 1, maxLength: 18 },
  "HI05-6": { minLength: 1, maxLength: 15 },
  "HI05-7": { minLength: 1, maxLength: 30 },
  "HI05-8": { minLength: 1, maxLength: 30 },
  "HI05-9": { minLength: 1, maxLength: 1 },
  "HI06-1": { minLength: 1, maxLength: 3 },
  "HI06-2": { minLength: 1, maxLength: 30 },
  "HI06-3": { minLength: 2, maxLength: 3 },
  "HI06-4": { minLength: 1, maxLength: 35 },
  "HI06-5": { minLength: 1, maxLength: 18 },
  "HI06-6": { minLength: 1, maxLength: 15 },
  "HI06-7": { minLength: 1, maxLength: 30 },
  "HI06-8": { minLength: 1, maxLength: 30 },
  "HI06-9": { minLength: 1, maxLength: 1 },
  "HI07-1": { minLength: 1, maxLength: 3 },
  "HI07-2": { minLength: 1, maxLength: 30 },
  "HI07-3": { minLength: 2, maxLength: 3 },
  "HI07-4": { minLength: 1, maxLength: 35 },
  "HI07-5": { minLength: 1, maxLength: 18 },
  "HI07-6": { minLength: 1, maxLength: 15 },
  "HI07-7": { minLength: 1, maxLength: 30 },
  "HI07-8": { minLength: 1, maxLength: 30 },
  "HI07-9": { minLength: 1, maxLength: 1 },
  "HI08-1": { minLength: 1, maxLength: 3 },
  "HI08-2": { minLength: 1, maxLength: 30 },
  "HI08-3": { minLength: 2, maxLength: 3 },
  "HI08-4": { minLength: 1, maxLength: 35 },
  "HI08-5": { minLength: 1, maxLength: 18 },
  "HI08-6": { minLength: 1, maxLength: 15 },
  "HI08-7": { minLength: 1, maxLength: 30 },
  "HI08-8": { minLength: 1, maxLength: 30 },
  "HI08-9": { minLength: 1, maxLength: 1 },
  "HI09-1": { minLength: 1, maxLength: 3 },
  "HI09-2": { minLength: 1, maxLength: 30 },
  "HI09-3": { minLength: 2, maxLength: 3 },
  "HI09-4": { minLength: 1, maxLength: 35 },
  "HI09-5": { minLength: 1, maxLength: 18 },
  "HI09-6": { minLength: 1, maxLength: 15 },
  "HI09-7": { minLength: 1, maxLength: 30 },
  "HI09-8": { minLength: 1, maxLength: 30 },
  "HI09-9": { minLength: 1, maxLength: 1 },
  "HI10-1": { minLength: 1, maxLength: 3 },
  "HI10-2": { minLength: 1, maxLength: 30 },
  "HI10-3": { minLength: 2, maxLength: 3 },
  "HI10-4": { minLength: 1, maxLength: 35 },
  "HI10-5": { minLength: 1, maxLength: 18 },
  "HI10-6": { minLength: 1, maxLength: 15 },
  "HI10-7": { minLength: 1, maxLength: 30 },
  "HI10-8": { minLength: 1, maxLength: 30 },
  "HI10-9": { minLength: 1, maxLength: 1 },
  "HI11-1": { minLength: 1, maxLength: 3 },
  "HI11-2": { minLength: 1, maxLength: 30 },
  "HI11-3": { minLength: 2, maxLength: 3 },
  "HI11-4": { minLength: 1, maxLength: 35 },
  "HI11-5": { minLength: 1, maxLength: 18 },
  "HI11-6": { minLength: 1, maxLength: 15 },
  "HI11-7": { minLength: 1, maxLength: 30 },
  "HI11-8": { minLength: 1, maxLength: 30 },
  "HI11-9": { minLength: 1, maxLength: 1 },
  "HI12-1": { minLength: 1, maxLength: 3 },
  "HI12-2": { minLength: 1, maxLength: 30 },
  "HI12-3": { minLength: 2, maxLength: 3 },
  "HI12-4": { minLength: 1, maxLength: 35 },
  "HI12-5": { minLength: 1, maxLength: 18 },
  "HI12-6": { minLength: 1, maxLength: 15 },
  "HI12-7": { minLength: 1, maxLength: 30 },
  "HI12-8": { minLength: 1, maxLength: 30 },
  "HI12-9": { minLength: 1, maxLength: 1 },
  "HL01": { minLength: 1, maxLength: 12 },
  "HL02": { minLength: 1, maxLength: 12 },
  "HL03": { minLength: 1, maxLength: 2 },
  "HL04": { minLength: 1, maxLength: 1 },
  "HSD01": { minLength: 2, maxLength: 2 },
  "HSD02": { minLength: 1, maxLength: 15 },
  "HSD03": { minLength: 2, maxLength: 2 },
  "HSD04": { minLength: 1, maxLength: 6 },
  "HSD05": { minLength: 1, maxLength: 2 },
  "HSD06": { minLength: 1, maxLength: 3 },
  "HSD07": { minLength: 1, maxLength: 2 },
  "HSD08": { minLength: 1, maxLength: 1 },
  "IEA01": { minLength: 1, maxLength: 5 },
  "IEA02": { minLength: 9, maxLength: 9 },
  "INS01": { minLength: 1, maxLength: 1 },
  "INS02": { minLength: 2, maxLength: 2 },
  "INS03": { minLength: 3, maxLength: 3 },
  "INS04": { minLength: 2, maxLength: 3 },
  "INS05": { minLength: 1, maxLength: 1 },
  "INS08": { minLength: 2, maxLength: 2 },
  "INS09": { minLength: 1, maxLength: 1 },
  "INS10": { minLength: 1, maxLength: 1 },
  "INS11": { minLength: 2, maxLength: 3 },
  "INS12": { minLength: 1, maxLength: 35 },
  "INS13": { minLength: 1, maxLength: 1 },
  "INS14": { minLength: 2, maxLength: 30 },
  "INS15": { minLength: 2, maxLength: 2 },
  "INS16": { minLength: 2, maxLength: 3 },
  "INS17": { minLength: 1, maxLength: 9 },
  "ISA01": { minLength: 2, maxLength: 2 },
  "ISA02": { minLength: 10, maxLength: 10 },
  "ISA03": { minLength: 2, maxLength: 2 },
  "ISA04": { minLength: 10, maxLength: 10 },
  "ISA05": { minLength: 2, maxLength: 2 },
  "ISA06": { minLength: 15, maxLength: 15 },
  "ISA07": { minLength: 2, maxLength: 2 },
  "ISA08": { minLength: 15, maxLength: 15 },
  "ISA09": { minLength: 6, maxLength: 6 },
  "ISA10": { minLength: 4, maxLength: 4 },
  "ISA11": { minLength: 1, maxLength: 1 },
  "ISA12": { minLength: 5, maxLength: 5 },
  "ISA13": { minLength: 9, maxLength: 9 },
  "ISA14": { minLength: 1, maxLength: 1 },
  "ISA15": { minLength: 1, maxLength: 1 },
  "ISA16": { minLength: 1, maxLength: 1 },
  "MSG01": { minLength: 1, maxLength: 264 },
  "MSG02": { minLength: 2, maxLength: 2 },
  "MSG03": { minLength: 1, maxLength: 9 },
  "N301": { minLength: 1, maxLength: 55 },
  "N302": { minLength: 1, maxLength: 55 },
  "N401": { minLength: 2, maxLength: 30 },
  "N402": { minLength: 2, maxLength: 2 },
  "N403": { minLength: 3, maxLength: 15 },
  "N404": { minLength: 2, maxLength: 3 },
  "N405": { minLength: 1, maxLength: 2 },
  "N406": { minLength: 1, maxLength: 30 },
  "N407": { minLength: 1, maxLength: 3 },
  "NM101": { minLength: 2, maxLength: 3 },
  "NM102": { minLength: 1, maxLength: 1 },
  "NM103": { minLength: 1, maxLength: 60 },
  "NM104": { minLength: 1, maxLength: 35 },
  "NM105": { minLength: 1, maxLength: 25 },
  "NM106": { minLength: 1, maxLength: 10 },
  "NM107": { minLength: 1, maxLength: 10 },
  "NM108": { minLength: 1, maxLength: 2 },
  "NM109": { minLength: 2, maxLength: 80 },
  "NM110": { minLength: 2, maxLength: 2 },
  "NM111": { minLength: 2, maxLength: 3 },
  "NM112": { minLength: 1, maxLength: 60 },
  "PER01": { minLength: 2, maxLength: 2 },
  "PER02": { minLength: 1, maxLength: 60 },
  "PER03": { minLength: 2, maxLength: 2 },
  "PER04": { minLength: 1, maxLength: 256 },
  "PER05": { minLength: 2, maxLength: 2 },
  "PER06": { minLength: 1, maxLength: 256 },
  "PER07": { minLength: 2, maxLength: 2 },
  "PER08": { minLength: 1, maxLength: 256 },
  "PER09": { minLength: 1, maxLength: 20 },
  "PRV01": { minLength: 1, maxLength: 3 },
  "PRV02": { minLength: 2, maxLength: 3 },
  "PRV03": { minLength: 1, maxLength: 50 },
  "PRV04": { minLength: 2, maxLength: 2 },
  "PRV06": { minLength: 3, maxLength: 3 },
  "PWK01": { minLength: 2, maxLength: 2 },
  "PWK02": { minLength: 1, maxLength: 2 },
  "PWK03": { minLength: 1, maxLength: 2 },
  "PWK04": { minLength: 2, maxLength: 3 },
  "PWK05": { minLength: 1, maxLength: 2 },
  "PWK06": { minLength: 2, maxLength: 80 },
  "PWK07": { minLength: 1, maxLength: 80 },
  "PWK09": { minLength: 1, maxLength: 2 },
  "REF01": { minLength: 2, maxLength: 3 },
  "REF02": { minLength: 1, maxLength: 50 },
  "REF03": { minLength: 1, maxLength: 80 },
  "REF04-1": { minLength: 2, maxLength: 3 },
  "REF04-2": { minLength: 1, maxLength: 50 },
  "REF04-3": { minLength: 2, maxLength: 3 },
  "REF04-4": { minLength: 1, maxLength: 50 },
  "REF04-5": { minLength: 2, maxLength: 3 },
  "REF04-6": { minLength: 1, maxLength: 50 },
  "SE01": { minLength: 1, maxLength: 10 },
  "SE02": { minLength: 4, maxLength: 9 },
  "ST01": { minLength: 3, maxLength: 3 },
  "ST02": { minLength: 4, maxLength: 9 },
  "ST03": { minLength: 1, maxLength: 35 },
  "SV101-1": { minLength: 2, maxLength: 2 },
  "SV101-2": { minLength: 1, maxLength: 48 },
  "SV101-3": { minLength: 2, maxLength: 2 },
  "SV101-4": { minLength: 2, maxLength: 2 },
  "SV101-5": { minLength: 2, maxLength: 2 },
  "SV101-6": { minLength: 2, maxLength: 2 },
  "SV101-7": { minLength: 1, maxLength: 80 },
  "SV101-8": { minLength: 1, maxLength: 48 },
  "SV102": { minLength: 1, maxLength: 18 },
  "SV103": { minLength: 2, maxLength: 2 },
  "SV104": { minLength: 1, maxLength: 15 },
  "SV105": { minLength: 1, maxLength: 2 },
  "SV106": { minLength: 1, maxLength: 2 },
  "SV107-1": { minLength: 1, maxLength: 2 },
  "SV107-2": { minLength: 1, maxLength: 2 },
  "SV107-3": { minLength: 1, maxLength: 2 },
  "SV107-4": { minLength: 1, maxLength: 2 },
  "SV108": { minLength: 1, maxLength: 18 },
  "SV109": { minLength: 1, maxLength: 1 },
  "SV110": { minLength: 1, maxLength: 2 },
  "SV111": { minLength: 1, maxLength: 1 },
  "SV112": { minLength: 1, maxLength: 1 },
  "SV113": { minLength: 1, maxLength: 2 },
  "SV114": { minLength: 1, maxLength: 2 },
  "SV115": { minLength: 1, maxLength: 1 },
  "SV116": { minLength: 1, maxLength: 1 },
  "SV117": { minLength: 1, maxLength: 50 },
  "SV118": { minLength: 3, maxLength: 15 },
  "SV119": { minLength: 1, maxLength: 18 },
  "SV120": { minLength: 1, maxLength: 1 },
  "SV121": { minLength: 1, maxLength: 1 },
  "SV201": { minLength: 1, maxLength: 48 },
  "SV202-1": { minLength: 2, maxLength: 2 },
  "SV202-2": { minLength: 1, maxLength: 48 },
  "SV202-3": { minLength: 2, maxLength: 2 },
  "SV202-4": { minLength: 2, maxLength: 2 },
  "SV202-5": { minLength: 2, maxLength: 2 },
  "SV202-6": { minLength: 2, maxLength: 2 },
  "SV202-7": { minLength: 1, maxLength: 80 },
  "SV202-8": { minLength: 1, maxLength: 48 },
  "SV203": { minLength: 1, maxLength: 18 },
  "SV204": { minLength: 2, maxLength: 2 },
  "SV205": { minLength: 1, maxLength: 15 },
  "SV206": { minLength: 1, maxLength: 10 },
  "SV207": { minLength: 1, maxLength: 18 },
  "SV208": { minLength: 1, maxLength: 1 },
  "SV209": { minLength: 1, maxLength: 1 },
  "SV210": { minLength: 1, maxLength: 1 },
  "SV301-1": { minLength: 2, maxLength: 2 },
  "SV301-2": { minLength: 1, maxLength: 48 },
  "SV301-3": { minLength: 2, maxLength: 2 },
  "SV301-4": { minLength: 2, maxLength: 2 },
  "SV301-5": { minLength: 2, maxLength: 2 },
  "SV301-6": { minLength: 2, maxLength: 2 },
  "SV301-7": { minLength: 1, maxLength: 80 },
  "SV301-8": { minLength: 1, maxLength: 48 },
  "SV302": { minLength: 1, maxLength: 18 },
  "SV303": { minLength: 1, maxLength: 2 },
  "SV304-1": { minLength: 1, maxLength: 3 },
  "SV304-2": { minLength: 1, maxLength: 3 },
  "SV304-3": { minLength: 1, maxLength: 3 },
  "SV304-4": { minLength: 1, maxLength: 3 },
  "SV304-5": { minLength: 1, maxLength: 3 },
  "SV305": { minLength: 1, maxLength: 1 },
  "SV306": { minLength: 1, maxLength: 15 },
  "SV307": { minLength: 1, maxLength: 80 },
  "SV308": { minLength: 1, maxLength: 1 },
  "SV309": { minLength: 1, maxLength: 1 },
  "SV310": { minLength: 1, maxLength: 1 },
  "SVC01-1": { minLength: 2, maxLength: 2 },
  "SVC01-2": { minLength: 1, maxLength: 48 },
  "SVC01-3": { minLength: 2, maxLength: 2 },
  "SVC01-4": { minLength: 2, maxLength: 2 },
  "SVC01-5": { minLength: 2, maxLength: 2 },
  "SVC01-6": { minLength: 2, maxLength: 2 },
  "SVC01-7": { minLength: 1, maxLength: 80 },
  "SVC02": { minLength: 1, maxLength: 18 },
  "SVC03": { minLength: 1, maxLength: 18 },
  "SVC04": { minLength: 1, maxLength: 48 },
  "TOO01": { minLength: 1, maxLength: 3 },
  "TOO02": { minLength: 1, maxLength: 30 },
  "TOO03-1": { minLength: 1, maxLength: 2 },
  "TOO03-2": { minLength: 1, maxLength: 2 },
  "TOO03-3": { minLength: 1, maxLength: 2 },
  "TOO03-4": { minLength: 1, maxLength: 2 },
  "TOO03-5": { minLength: 1, maxLength: 2 },
  "TRN01": { minLength: 1, maxLength: 2 },
  "TRN02": { minLength: 1, maxLength: 50 },
  "TRN03": { minLength: 10, maxLength: 10 },
  "TRN04": { minLength: 1, maxLength: 50 },
  "UM01": { minLength: 1, maxLength: 2 },
  "UM02": { minLength: 1, maxLength: 1 },
  "UM03": { minLength: 1, maxLength: 2 },
  "UM04-1": { minLength: 1, maxLength: 2 },
  "UM04-2": { minLength: 1, maxLength: 2 },
  "UM04-3": { minLength: 1, maxLength: 1 },
  "UM05-1": { minLength: 2, maxLength: 3 },
  "UM05-2": { minLength: 2, maxLength: 3 },
  "UM05-3": { minLength: 2, maxLength: 3 },
  "UM05-4": { minLength: 2, maxLength: 2 },
  "UM05-5": { minLength: 2, maxLength: 3 },
  "UM06": { minLength: 1, maxLength: 3 },
  "UM07": { minLength: 1, maxLength: 1 },
  "UM08": { minLength: 1, maxLength: 1 },
  "UM09": { minLength: 1, maxLength: 1 },
  "UM10": { minLength: 1, maxLength: 2 },
};

export function lookupElementLength(refDes) {
  if (!refDes) return null;
  return ELEMENT_LENGTH_BY_REF_DES[refDes] ?? null;
}
